import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../..";
import { FORGOTPASSWORD_API, REGISTER_STEP2_API } from "../../app/constants";
import BtnLoader from "../BtnLoader";

const RegisterStep2 = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const phoneNumber = sessionStorage.getItem("phoneNumber");
  const userId = sessionStorage.getItem("userId");
  const otpflow = sessionStorage.getItem("otpflow") === "true";
  const otpMessage = sessionStorage.getItem("otpMessage");

  const handleInputChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value.slice(0, 1);
    setOtp(newOtp);

    if (e.target.value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }

    // Trigger auto-submit if all fields are filled
    if (newOtp.every((digit) => digit !== "")) {
      handleVerify(newOtp.join(""));
    }
  };

  const handleVerify = async (otpCode = otp.join("")) => {
    setIsLoading(true);
    try {
      console.log("Verifying OTP:", otpCode);

      const response = await axios.get(
        `${BASE_URL}${REGISTER_STEP2_API}/${otpCode}/${userId}`
      );

      if (response.status === 200 && response.data.code === 1) {
        sessionStorage.setItem("resetToken", response.data.data.resetToken);
        sessionStorage.removeItem("otpflow");
        navigate(otpflow ? "/reset-password" : "/signup");
      } else {
        const errorMessage =
          response.data?.message || "Invalid OTP! Please try again.";
        setError(errorMessage);
      }
    } catch (err) {
      console.error("Error during OTP verification:", err);
      const errorMessage =
        err.response?.data?.message ||
        "Something went wrong during verification. Please try again.";
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !otp.includes("")) {
      handleVerify();
    }
  };

  const handleResendOtp = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}${FORGOTPASSWORD_API}`, {
        phoneNumber,
      });

      if (response.status === 200 && response.data.code === 1) {
        sessionStorage.setItem("phoneNumber", phoneNumber);
        sessionStorage.setItem("userId", response.data.data.id);
        sessionStorage.setItem("otpMessage", response.data.message);
      } else {
        const errorMessage =
          response.data?.message || "Failed to resend OTP. Please try again.";
        setError(errorMessage);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="flex-center bg-light">
      <div className="container container-lg flex-center bg-white py-40">
        <div className="gy-4 rounded bg-white d-flex flex-column flex-lg-row gap-10">
          <div
            className="col-xl-6 p-0 order-lg-1 order-2 flex-center flex-column mt-0"
            style={{
              maxWidth: "26rem",
              minHeight: "33rem",
              background:
                "linear-gradient(to bottom, #FE5014, #FE5014, #FD9B7B, #FFC6C6)",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <h4 className="text-capitalize text-white p-20 pt-40">
              Shopping with lowest prices & maximum discounts
            </h4>
            <p className="text-white px-20">
              We are connected with wholesalers to offer the best price on every
              item you buy
            </p>
            <img
              className="mt-40"
              src="assets/images/icon/login-img.png"
              alt="LoginImg"
              style={{ objectFit: "cover" }}
            />
          </div>

          <div
            className="bg-white p-24 order-lg-2 order-1 p-md-5 d-flex flex-column justify-content-center rounded-lg"
            style={{ maxWidth: "23rem", width: "100%" }}
          >
            <div className="flex-center flex-column mb-24">
              <img
                style={{ width: "10rem" }}
                src="assets/images/logo/header_logo.png"
                alt="Lazmy Official Logo"
              />
              <p className="text-2xl fw-bolder text-black">
                Verify Your Identity
              </p>
              <p className="text-xs text-muted text-center">{otpMessage}</p>
            </div>

            <div className="d-flex justify-content-between my-14">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="number"
                  className="common-input text-center rounded-0"
                  style={{ maxWidth: "5rem" }}
                  placeholder="—"
                  value={digit}
                  onChange={(e) => handleInputChange(e, index)}
                  onKeyDown={
                    index === otp.length - 1 ? handleKeyDown : undefined
                  }
                />
              ))}
            </div>

            {error && <p className="text-danger text-sm mb-24">{error}</p>}

            <button
              type="button"
              className="w-100 btn py-18 px-40 rounded-0 shadow"
              style={{ background: "#FE5014" }}
              onClick={() => handleVerify()}
              disabled={isLoading || otp.includes("")}
            >
              {isLoading ? <BtnLoader /> : "Verify OTP"}
            </button>

            <div className="text-center my-14">
              <p className="text-sm text-muted">
                Didn’t receive the code?{" "}
                <a
                  href="#"
                  className="text-primary cursor-pointer"
                  onClick={handleResendOtp}
                >
                  Resend OTP
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterStep2;
